import React from 'react';
import { InfoIcon } from 'lucide-react';
export function LegalNotice() {
  return <section aria-labelledby="aviso-importante" className="mx-auto w-full max-w-4xl px-4 pb-12 pt-4 sm:px-6 lg:px-8" data-id="element-228" data-mp="1djbe30w1epio">
      <div className="rounded-2xl border border-brand-blue/20 bg-white p-6 md:p-7" data-id="element-229" data-mp="1ihwi7beettce">
        <h2 id="aviso-importante" className="mb-3 flex items-center gap-2 font-title text-xs font-bold tracking-[.18em] text-brand-blue md:text-sm" data-id="element-230" data-mp="1ni0xiy3l0i11">
          <InfoIcon className="h-4 w-4 text-brand-goldDark" data-id="element-231" data-mp="1wi7748w5sxux" />
          AVISO IMPORTANTE
        </h2>
        <p className="text-[13px] leading-relaxed text-brand-textLight md:text-sm" data-id="element-232" data-mp="218nna0rd6xkz">
          KIT MAESTRO DE BIODESCODIFICACIÓN™ es material digital de carácter educativo. Sus contenidos y recursos
          están destinados a organización, reflexión y acompañamiento dentro del alcance profesional de cada usuario.
          No constituyen diagnóstico ni tratamiento médico, psicológico o psiquiátrico y no sustituyen la atención de
          profesionales de la salud. Ante síntomas, urgencias o situaciones de riesgo corresponde consultar o derivar
          a profesionales habilitados.
        </p>
      </div>
    </section>;
}